// extracted by mini-css-extract-plugin
module.exports = {"orderSection":"order-details_orderSection__jQROq","orderTable":"order-details_orderTable__3X5eO"};